import React from 'react';
import { Body, Box, Heading, ListItem, UnorderedList } from '@hover/blueprint';
import { AnchorLink } from 'gatsby-plugin-anchor-links';
import { ILink } from '../../interfaces/ILink';

interface Props {
  tableData: Array<ILink>;
}

const TableOfContent: React.FC<Props> = ({ tableData }) => (
  <Box flexDir="column" mb={{ base: 600, tablet: '56px' }}>
    <Heading as="h2" size={500} fontWeight={400} marginBottom={500}>
      Table of contents
    </Heading>
    <UnorderedList ml={0}>
      {tableData.map(link => (
        <ListItem key={link.label}>
          <AnchorLink to={link.to} stripHash>
            <Body as="span" color="primary.600" isSemiBold>
              {link.label}
            </Body>
          </AnchorLink>
        </ListItem>
      ))}
    </UnorderedList>
  </Box>
);

export default TableOfContent;
